'use strict';

const createOneClickCheckoutFactory = require('./main_creator');

module.exports = createOneClickCheckoutFactory({
    viewClass: require('./view.mobile'),
    isEnabled() {
        return Odigeo.AB.isOneClickCheckout || Odigeo.AB.isOneClickCheckoutCheckinMicrofunnel;
    },
});
